<div class="card-body">
    <ngx-extended-pdf-viewer [src]="pdfUrl"
                             [useBrowserLocale]="true"
                             style="display: block"
                             [height]="'100%'"
                             [showHandToolButton]="true"
                             [textLayer]="true">
    </ngx-extended-pdf-viewer>
</div>
